import type { RequestResponse } from '@/types/publicType'
import type {
  clientInitInterface,
  getLuckyPopupInterface
} from '@/types/apiType/publicTyps'

/**
 * 初始化接口
 * -初始化表情信息
 */
export function apiGetClientInit(): Promise<
  RequestResponse<clientInitInterface>
> {
  return getFetchData({
    url: '/client/init',
    method: 'GET'
  })
}

/**
 * 幸运弹窗计数一次充值
 */
export function apiLuckyTrigger(): Promise<RequestResponse<boolean>> {
  return getFetchData({
    url: '/h5/u/lucky-popup/trigger',
    method: 'GET'
  })
}

/**
 * 获取幸运弹窗 - 倒计时
 */
export function apiGetLuckyPopup(): Promise<
  RequestResponse<getLuckyPopupInterface>
> {
  return getFetchData({
    url: '/h5/u/lucky-popup',
    method: 'GET'
  })
}
